<template>
  <!--
    Action-required transcript-deadline banner (ACC-355, Figma 1131-109406).
    Shown above the Courses panel when a learner has courses whose transcript
    window is closing (<= 10 days). Lists the approaching course codes.
  -->
  <div class="transcript-deadline-banner" role="alert">
    <v-icon class="transcript-deadline-banner__icon" size="24">mdi-clock</v-icon>
    <div class="transcript-deadline-banner__body">
      <p class="transcript-deadline-banner__heading">Deadline approaching</p>
      <p class="transcript-deadline-banner__text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TranscriptDeadlineBanner',

  props: {
    /** Course codes approaching their transcript deadline, e.g. ['MAT 117', 'HST 109']. */
    courseCodes: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    codesText() {
      return this.courseCodes.join(', ');
    },
    // Wording per Natalie on ACC-355, with singular/plural agreement.
    text() {
      const single = this.courseCodes.length === 1;
      const opening = single
        ? `${this.codesText} is approaching its`
        : `The following courses ${this.codesText} are approaching their`;
      const add = single ? 'Add it now' : 'Add them now';
      return `${opening} transcript deadline. ${add} to avoid losing the opportunity to transcript your credit.`;
    }
  }
});
</script>

<style lang="scss" scoped>
.transcript-deadline-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  border-radius: 4px;
  background: var(--system-colors-info-background, #d6f0fa);

  &__icon {
    flex-shrink: 0;
    color: #191919;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    color: #191919;
    font-family: Arial, sans-serif;
    word-break: break-word;
  }

  &__heading {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.48px;
  }

  &__text {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    a {
      color: inherit;
      text-decoration: underline;
    }
  }
}
</style>
